import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import {getUserInfo} from "../restful/api";
Vue.use(Vuex);

let store = new Vuex.Store({
	state:{
		userInfo:{},
	},
	// 修改state的唯一方法 是提交mutations
	mutations:{
		SetUserInfo(state,user){
			state.userInfo = user;
		},
	},
  getters: {
    //get方法
    getUserInfo: state => state.userInfo

  },
	actions:{
    SetUserInfo({commit},user){
			commit('SetUserInfo',user);
		},
	}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js